export function isPageInIframe() {
  try {
    return !!window.self && !!window.top && window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export const isInIframe: boolean = isPageInIframe();
